import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { normalizeCapabilities } from '@rsos/capstone';
import { fetchPsapInfo } from '../capstoneAPI';

/* this works like an action, the creators are automatically produced thanks to createAsyncThunk */
/* they are listed in extra reducers */
export const fetchPsap = createAsyncThunk(
  'psap/fetchPsapInfo',
  async endpoint => {
    try {
      const response = await fetchPsapInfo(endpoint);
      return response.data;
    } catch (err) {
      return err;
    }
  },
);

export const initialState = {
  loading: false,
  hasErrors: false,
  currentPSAP: {},
};

const psapInfo = createSlice({
  name: 'psapInfo',
  initialState,
  reducers: {},
  extraReducers: {
    [fetchPsap.fulfilled]: (state, action) => {
      /* On success this is the logic that updates the state with data */
      state.currentPSAP = {
        ...action.payload,
        activeCapabilities: normalizeCapabilities(
          action.payload.active_capabilities,
        ),
      };
      state.loading = false;
      state.hasErrors = false;
    },
    [fetchPsap.pending]: state => {
      /* this is where a loading bool/state is set */
      state.loading = true;
    },
    [fetchPsap.rejected]: (state, action) => {
      /* this is how we can get an Error set */
      state.loading = false;
      state.hasErrors = action.payload;
    },
  },
});

export const {
  getPsapInfo,
  getPsapInfoSuccess,
  getPsapInfoFailure,
} = psapInfo.actions;

export const psapSelector = state => state.psaps;

export const psaps = psapInfo.reducer;
export default psaps;
